import React from 'react'
import { Card, Spinner } from '@shopify/polaris'
import LappaPolarisDataTableShell from 'components/LappaPolarisDataTableShell'
import NoDataMessage from 'components/NoDataMessage/NoDataMessage'
import { ReactComponent as ReminderImg } from 'img/illustrations/general/reminder-img.svg'
import { getPeriodTypeForVat } from '../utils/periodUtils'
import { getStatusForVat } from '../utils/statusUtils'
import _ from 'lodash'

const VatReturnsSection = ({ declarations, fetchingDeclarations, user, t, navigate }) => {
	const rows = declarations ? declarations.items : []

	return (
		<Card sectioned={fetchingDeclarations || _.isEmpty(rows)}>
			{fetchingDeclarations ? (
				<Spinner />
			) : (
				<>
					<div style={{ display: "flex", justifyContent: "space-between", alignItems: 'flex-start' }}>
						<h2 style={{ fontSize: 18, fontWeight: '600' }}>{t("home.title.vatRet")}</h2>
						<button
							style={{
								maxHeight: '20px',
								borderColor: 'transparent',
								boxShadow: 'none',
								background: 'transparent',
								height: 'auto',
								color: 'rgba(44, 110, 203, 1)',
								fontSize: 14,
								fontWeight: 400,
								cursor: 'pointer'
							}}
							onClick={() => navigate("/vat-returns")}
						>
							{t("home.viewAll")}
						</button>
					</div>
					{!_.isEmpty(rows) && !fetchingDeclarations && (
						<>
							<br />
							<div className='border-top table-dashboard-returns'>
								<LappaPolarisDataTableShell
									columnContentTypes={[
										"text",
										"text",
										"text",
										"numeric",
									]}
									headings={[]}
									rows={[...rows].map((rowData) => [
										rowData.customer_country.name,
										getPeriodTypeForVat(rowData.period_type, t),
										`${rowData.period} ${rowData.period_type} ${rowData.period_year}`,
										getStatusForVat(rowData.status, t),
									])}
								/>
							</div>
						</>
					)}
					{_.isEmpty(rows) && !fetchingDeclarations && (
						<div>
							<NoDataMessage
								title={t("home.noDataYet")}
								description={t("home.addVatReturnsToSeeData")}
								buttonText={
									user.vat_returns_show_in_menu
										? t("home.addVatReturns")
										: null
								}
								Image={ReminderImg}
								style={{ height: "auto" }}
								onClick={() => navigate("/vat-returns/create-return")}
							/>
						</div>
					)}
				</>
			)}
		</Card>
	)
}

export default VatReturnsSection

